import React, { ComponentProps, forwardRef } from 'react';

interface IconProps extends ComponentProps<'svg'> {
  width?: string;
  height?: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ width = '1em', height = '1em', icon: IconComponent, ...props }, ref) => (
    <IconComponent ref={ref} width={width} height={height} {...props} />
  ),
);
